/**
 * ベッドタイプ注意書き用の共通スタイル定義
 * モーダル表示用（PC/SP共通）
 */
export const BedTypeNoticeStyle = {
  color: '#dc3545',
  fontSize: '0.85em',
  padding: '0 5px',
  marginTop: '4px'
} as const;
